(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel() {
      const carousels = document.querySelectorAll('.about-carousel');
      
      carousels.forEach(function(carousel) {
        if (carousel.dataset.carouselReady === 'true') {
          return;
        }
        carousel.dataset.carouselReady = 'true';

        const track = carousel.querySelector('.about-carousel-track');
        const slides = carousel.querySelectorAll('.about-carousel-slide');
        const section = carousel.closest('section');
        const prevBtn = section ? section.querySelector('.about-carousel-prev') : null;
        const nextBtn = section ? section.querySelector('.about-carousel-next') : null;

        if (!track) return;
        
        // If no slides, don't initialize carousel functionality
        if (slides.length === 0) {
          track.style.transform = 'translateX(0px)';
          return;
        }

        let currentIndex = 0;
        let isMobile = window.innerWidth < 1024;
        let autoScrollTimer = null;

        function getTrackGap() {
          const styles = window.getComputedStyle(track);
          const gapValue = parseFloat(styles.columnGap || styles.gap || '0');
          return Number.isNaN(gapValue) ? 0 : gapValue;
        }

        function getSlideWidth() {
          if (slides.length === 0) return 0;
          const slide = slides[0];
          const gap = getTrackGap();
          const width = slide.offsetWidth || slide.getBoundingClientRect().width;
          return width + gap;
        }

        function getMaxTranslateX() {
          const maxTranslate = track.scrollWidth - carousel.clientWidth;
          return Math.max(0, maxTranslate);
        }

        function updateCarousel() {
          if (slides.length === 0) {
            track.style.transform = 'translateX(0px)';
            return;
          }
          const slideWidth = getSlideWidth();
          const desiredTranslate = currentIndex * slideWidth;
          const translateX = -Math.min(desiredTranslate, getMaxTranslateX());
          track.style.transform = 'translateX(' + translateX + 'px)';
        }

        function goToSlide(index) {
          const maxIndex = Math.max(0, slides.length - 1);
          currentIndex = Math.max(0, Math.min(index, maxIndex));
          updateCarousel();
        }

        function goToNext() {
          const maxIndex = Math.max(0, slides.length - 1);
          if (currentIndex < maxIndex) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(0);
          }
        }

        function goToPrev() {
          if (currentIndex > 0) {
            goToSlide(currentIndex - 1);
          } else {
            const maxIndex = Math.max(0, slides.length - 1);
            goToSlide(maxIndex);
          }
        }

        function startAutoScroll() {
          stopAutoScroll();
          if (slides.length <= 1) return;
          autoScrollTimer = window.setInterval(function() {
            goToNext();
          }, 3000);
        }

        function stopAutoScroll() {
          if (autoScrollTimer) {
            window.clearInterval(autoScrollTimer);
            autoScrollTimer = null;
          }
        }

        if (prevBtn) {
          prevBtn.addEventListener('click', function() {
            goToPrev();
            startAutoScroll();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', function() {
            goToNext();
            startAutoScroll();
          });
        }

        // Touch/swipe support
        let startX = 0;
        let isDragging = false;
        let startTranslateX = 0;

        track.addEventListener('touchstart', function(e) {
          stopAutoScroll();
          startX = e.touches[0].clientX;
          isDragging = true;
          startTranslateX = currentIndex * getSlideWidth();
        });

        track.addEventListener('touchmove', function(e) {
          if (!isDragging) return;
          e.preventDefault();
          const currentX = e.touches[0].clientX;
          const diff = startX - currentX;
          const translateX = startTranslateX - diff;
          track.style.transform = 'translateX(-' + Math.max(0, translateX) + 'px)';
        });

        track.addEventListener('touchend', function(e) {
          if (!isDragging) return;
          isDragging = false;
          const endX = e.changedTouches[0].clientX;
          const diff = startX - endX;

          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              goToNext();
            } else {
              goToPrev();
            }
          } else {
            updateCarousel();
          }
          startAutoScroll();
        });

        carousel.addEventListener('mouseenter', stopAutoScroll);
        carousel.addEventListener('mouseleave', startAutoScroll);
        carousel.addEventListener('focusin', stopAutoScroll);
        carousel.addEventListener('focusout', startAutoScroll);

        // Handle resize
        let resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
            const wasMobile = isMobile;
            isMobile = window.innerWidth < 1024;
            if (wasMobile !== isMobile) {
              currentIndex = 0;
            }
            updateCarousel();
          }, 250);
        });

        // Initial update - wait for images to load
        if (document.readyState === 'complete') {
          updateCarousel();
          startAutoScroll();
        } else {
          window.addEventListener('load', function() {
            setTimeout(function() {
              updateCarousel();
              startAutoScroll();
            }, 100);
          });
          updateCarousel();
        }
      });
    }

    // Initialize when DOM is ready
    function startInit() {
      // Wait a bit for content to render
      setTimeout(function() {
        initCarousel();
      }, 100);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startInit);
    } else {
      startInit();
    }

    // Re-initialize on section load (for theme editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(initCarousel, 100);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.quote-extra').forEach(function (card) {
      var addBtn = card.querySelector('[data-add-extra]');
      var priceEl = card.querySelector('[data-extra-price-label]');
      card.querySelectorAll('[data-extra-variant]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          card.querySelectorAll('[data-extra-variant]').forEach(function (other) {
            other.classList.remove('is-selected');
          });
          swatch.classList.add('is-selected');
          if (addBtn) {
            addBtn.dataset.variantId = swatch.getAttribute('data-extra-variant');
            addBtn.disabled = swatch.disabled;
          }
          if (priceEl) priceEl.textContent = swatch.getAttribute('data-extra-price') || '';
        });
      });
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var variantId = addBtn.dataset.variantId;
          if (!variantId || addBtn.disabled) return;
          addBtn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          }).then(function (res) {
            if (!res.ok) throw new Error('add failed');
            window.location.reload();
          }).catch(function () {
            addBtn.disabled = false;
          });
        });
      }
    });

    var flow = document.getElementById('quote-flow');
    if (!flow) return;

    var currentStep = 1;
    var cartForm = document.getElementById('cart-form');
    var nameInput = document.getElementById('quote-name');
    var emailInput = document.getElementById('quote-email');
    var phoneInput = document.getElementById('quote-phone');
    var companyInput = document.getElementById('quote-company');
    var addressInput = document.getElementById('quote-address');
    var zipCodeInput = document.getElementById('quote-zip-code');
    var stateInput = document.getElementById('quote-state');
    var townInput = document.getElementById('quote-town');
    var countryInput = document.getElementById('quote-country');
    var messageInput = document.getElementById('quote-message');
    var searchInput = document.getElementById('quote-product-search');
    var searchEmpty = flow.querySelector('[data-search-empty]');

    function showStockAlert(line, stockCount) {
      var alertEl = line.querySelector('[data-stock-alert]');
      if (!alertEl) return;
      var boxesLeft = alertEl.querySelector('[data-boxes-left]');
      if (boxesLeft) boxesLeft.textContent = stockCount;
      alertEl.classList.remove('hidden');
    }

    function hideStockAlert(line) {
      var alertEl = line.querySelector('[data-stock-alert]');
      if (alertEl) alertEl.classList.add('hidden');
    }

    function clampQuantity(input, nextValue) {
      var line = input.closest('[data-cart-line]');
      if (!line) return true;

      var tracked = line.dataset.inventoryTracked === 'true';
      var stockCount = parseInt(line.dataset.stockCount, 10);
      var requested = nextValue !== undefined ? nextValue : parseInt(input.value, 10);
      if (isNaN(requested) || requested < 1) requested = 1;

      if (tracked && !isNaN(stockCount) && requested > stockCount) {
        if (stockCount >= 1) input.value = stockCount;
        showStockAlert(line, stockCount);
        return false;
      }

      input.value = requested;
      hideStockAlert(line);
      return true;
    }

    function formatLinePrice(cents) {
      var format = (cartForm && cartForm.getAttribute('data-money-format')) || 'R {{amount}}';
      var value = (Number(cents) / 100).toFixed(2);
      var parts = value.split('.');
      var grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var groupedDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return format
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, groupedDot)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grouped)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, groupedDot + ',' + parts[1])
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1])
        .replace(/\{\{\s*amount\s*\}\}/g, grouped + '.' + parts[1]);
    }

    function syncReviewQty(line, qty) {
      var key = line.dataset.lineKey;
      var row = flow.querySelector('[data-review-row="' + key + '"] [data-review-qty]');
      if (row) row.textContent = qty;
      var priceEl = line.querySelector('[data-line-price]');
      var unit = parseInt(line.dataset.unitPrice, 10);
      if (priceEl && !isNaN(unit)) priceEl.textContent = formatLinePrice(unit * qty);
    }

    function updateCartQty(line, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.dataset.lineKey, quantity: qty })
      });
    }

    if (cartForm) {
      cartForm.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var input = line.querySelector('[data-cart-qty]');
        if (!input) return;

        input.addEventListener('input', function () {
          if (input.value === '') return;
          clampQuantity(input);
          syncReviewQty(line, input.value);
        });

        input.addEventListener('change', function () {
          if (!clampQuantity(input)) return;
          syncReviewQty(line, input.value);
          updateCartQty(line, parseInt(input.value, 10));
        });
      });

      cartForm.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    var contactForm = document.getElementById('quote-contact-form');
    if (contactForm) {
      contactForm.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    function isOverStock() {
      var overStock = false;
      if (!cartForm) return false;
      cartForm.querySelectorAll('[data-cart-qty]').forEach(function (input) {
        if (!clampQuantity(input)) overStock = true;
      });
      return overStock;
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());
    }

    function markField(input, valid) {
      if (!input) return valid;
      input.classList.toggle('is-valid', valid && input.value.trim() !== '');
      input.classList.toggle('is-invalid', !valid);
      return valid;
    }

    function validateContact(showErrors) {
      var nameOk = nameInput && nameInput.value.trim() !== '';
      var emailOk = isValidEmail(emailInput && emailInput.value);
      var phoneOk = phoneInput && phoneInput.value.replace(/\D/g, '').length >= 7;
      var addressOk = addressInput && addressInput.value.trim() !== '';
      var zipCodeOk = zipCodeInput && zipCodeInput.value.trim() !== '';
      var stateOk = stateInput && stateInput.value.trim() !== '';
      var townOk = townInput && townInput.value.trim() !== '';
      var countryOk = countryInput && countryInput.value.trim() !== '';

      if (showErrors) {
        markField(nameInput, nameOk);
        markField(emailInput, emailOk);
        markField(phoneInput, phoneOk);
        markField(addressInput, addressOk);
        markField(zipCodeInput, zipCodeOk);
        markField(stateInput, stateOk);
        markField(townInput, townOk);
        markField(countryInput, countryOk);
      }

      return nameOk && emailOk && phoneOk && addressOk && zipCodeOk && stateOk && townOk && countryOk;
    }

    function fillReview() {
      var nameEl = flow.querySelector('[data-review-name]');
      var emailEl = flow.querySelector('[data-review-email]');
      var phoneEl = flow.querySelector('[data-review-phone]');
      var companyEl = flow.querySelector('[data-review-company]');
      var addressEl = flow.querySelector('[data-review-address]');
      var zipCodeEl = flow.querySelector('[data-review-zip-code]');
      var stateEl = flow.querySelector('[data-review-state]');
      var townEl = flow.querySelector('[data-review-town]');
      var countryEl = flow.querySelector('[data-review-country]');
      var messageEl = flow.querySelector('[data-review-message]');
      if (nameEl) nameEl.textContent = nameInput.value.trim();
      if (emailEl) emailEl.textContent = emailInput.value.trim();
      if (phoneEl) phoneEl.textContent = phoneInput.value.trim();
      if (companyEl) companyEl.textContent = companyInput.value.trim();
      if (addressEl) addressEl.textContent = addressInput.value.trim();
      if (zipCodeEl) zipCodeEl.textContent = zipCodeInput.value.trim();
      if (stateEl) stateEl.textContent = stateInput.value.trim();
      if (townEl) townEl.textContent = townInput.value.trim();
      if (countryEl) countryEl.textContent = countryInput.value.trim();
      if (messageEl) messageEl.textContent = messageInput.value.trim();
    }

    function setStep(step) {
      currentStep = step;

      flow.querySelectorAll('[data-step-panel]').forEach(function (panel) {
        panel.classList.toggle('hidden', Number(panel.dataset.stepPanel) !== step);
      });

      flow.querySelectorAll('[data-step-footer]').forEach(function (footer) {
        footer.classList.toggle('hidden', Number(footer.dataset.stepFooter) !== step);
      });

      flow.querySelectorAll('[data-step-btn]').forEach(function (btn) {
        var n = Number(btn.dataset.stepBtn);
        btn.classList.toggle('is-active', n === step);
        btn.classList.toggle('is-complete', n < step);
        if (n === step) btn.setAttribute('aria-current', 'step');
        else btn.removeAttribute('aria-current');
      });
    }

    function goTo(step) {
      if (step === currentStep) return;

      if (step > currentStep) {
        if (currentStep === 1 && isOverStock()) return;
        if (step >= 3 || currentStep === 2) {
          if (!validateContact(true)) {
            setStep(2);
            return;
          }
          fillReview();
        }
      }

      if (step === 3) fillReview();
      setStep(step);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    flow.querySelectorAll('[data-next-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(currentStep + 1);
      });
    });

    flow.querySelectorAll('[data-prev-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(currentStep - 1);
      });
    });

    flow.querySelectorAll('[data-step-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(Number(btn.dataset.stepBtn));
      });
    });

    [nameInput, emailInput, phoneInput, companyInput, addressInput, zipCodeInput, stateInput, townInput, countryInput, messageInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        if (input === nameInput || input === addressInput || input === zipCodeInput || input === stateInput || input === townInput || input === countryInput) {
          markField(input, input.value.trim() !== '');
        } else if (input === emailInput) markField(input, isValidEmail(input.value));
        else if (input === phoneInput) markField(input, input.value.replace(/\D/g, '').length >= 7);
        else if (input.value.trim()) input.classList.add('is-valid');
        else input.classList.remove('is-valid');
      });
    });

    function contactDetails() {
      return {
        name: nameInput ? nameInput.value.trim() : '',
        email: emailInput ? emailInput.value.trim() : '',
        phone: phoneInput ? phoneInput.value.trim() : '',
        company: companyInput ? companyInput.value.trim() : '',
        address: addressInput ? addressInput.value.trim() : '',
        zip_code: zipCodeInput ? zipCodeInput.value.trim() : '',
        state: stateInput ? stateInput.value.trim() : '',
        town: townInput ? townInput.value.trim() : '',
        country: countryInput ? countryInput.value.trim() : '',
        message: messageInput ? messageInput.value.trim() : ''
      };
    }

    var quoteError = flow.querySelector('[data-quote-error]');
    var quoteErrorText = flow.getAttribute('data-quote-error-text') || 'Could not send your quote request. Please try again.';
    var quoteQueue = Promise.resolve();

    function showQuoteError(message) {
      if (!quoteError) return;
      quoteError.textContent = message || quoteErrorText;
      quoteError.classList.remove('hidden');
    }

    function hideQuoteError() {
      if (!quoteError) return;
      quoteError.textContent = '';
      quoteError.classList.add('hidden');
    }

    function quoteLineItems(items) {
      return (items || []).map(function (item) {
        return {
          id: item.id,
          key: item.key,
          product_title: item.product_title,
          title: item.title,
          variant_title: item.variant_title,
          sku: item.sku,
          image: item.image,
          quantity: item.quantity,
          price: item.price,
          line_price: item.line_price,
          final_line_price: item.final_line_price,
          vendor: item.vendor
        };
      });
    }

    function clearCart() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }).then(function (res) {
        if (!res.ok) throw new Error('clear failed');
      });
    }

    function moneyAmount(cents) {
      var amount = Number(cents);
      if (!isFinite(amount)) return '0.00';
      return (amount / 100).toFixed(2);
    }

    function postJson(url, payload) {
      return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (body) {
          return { res: res, body: body };
        }).catch(function () {
          return { res: res, body: null };
        });
      });
    }

    function postQuote() {
      var webhookUrl = flow.getAttribute('data-quote-webhook') || '/apps/quotes';
      var contact = contactDetails();

      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var attrs = Object.assign({}, cart.attributes || {}, {
            quote_open: 'true',
            quote_status: 'requested',
            quote_currency: cart.currency || '',
            quote_requested: 'true',
            quote_name: contact.name,
            quote_email: contact.email,
            quote_phone: contact.phone,
            quote_company: contact.company,
            quote_address: contact.address,
            quote_zip_code: contact.zip_code,
            quote_state: contact.state,
            quote_town: contact.town,
            quote_country: contact.country,
            quote_message: contact.message
          });

          var payload = {
            cart_token: cart.token,
            currency_code: cart.currency,
            total_amount: moneyAmount(cart.total_price),
            item_count: cart.item_count,
            email: contact.email,
            customer_name: contact.name,
            customer_email: contact.email,
            customer_phone: contact.phone,
            company: contact.company,
            address: contact.address,
            zip_code: contact.zip_code,
            state: contact.state,
            town: contact.town,
            country: contact.country,
            message: contact.message,
            line_items: quoteLineItems(cart.items)
          };

          var saveAttributes = fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ attributes: attrs })
          }).catch(function () {});

          return saveAttributes.then(function () {
            return postJson(webhookUrl, payload);
          }).then(function (saved) {
            if (!saved.res || saved.res.status !== 200) {
              return { ok: false, error: (saved.body && saved.body.error) || quoteErrorText };
            }
            return { ok: true, id: saved.body && saved.body.id, name: saved.body && saved.body.name };
          });
        })
        .catch(function () {
          return { ok: false, error: quoteErrorText };
        });
    }

    function sendQuote() {
      var run = quoteQueue.then(function () {
        return postQuote();
      });
      quoteQueue = run.then(function () {}, function () {});
      return run;
    }

    var submitBtn = flow.querySelector('[data-submit-quote]');
    var consentInput = flow.querySelector('[data-quote-consent]');
    function syncSubmitEnabled() {
      if (!submitBtn || submitBtn.classList.contains('is-loading')) return;
      submitBtn.disabled = !(consentInput && consentInput.checked);
    }
    if (consentInput) {
      consentInput.addEventListener('change', syncSubmitEnabled);
    }
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!consentInput || !consentInput.checked) {
          syncSubmitEnabled();
          return;
        }
        if (!validateContact(true)) {
          setStep(2);
          return;
        }
        hideQuoteError();
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        sendQuote().then(function (result) {
          if (!result || !result.ok) {
            showQuoteError(result && result.error);
            submitBtn.classList.remove('is-loading');
            submitBtn.setAttribute('aria-busy', 'false');
            syncSubmitEnabled();
            return;
          }
          return clearCart().catch(function () {}).then(function () {
            window.location.href = flow.getAttribute('data-thanks-url');
          });
        }).catch(function () {
          showQuoteError(quoteErrorText);
          submitBtn.classList.remove('is-loading');
          submitBtn.setAttribute('aria-busy', 'false');
          syncSubmitEnabled();
        });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        var visible = 0;
        flow.querySelectorAll('[data-cart-line]').forEach(function (line) {
          var title = (line.dataset.productTitle || '').toLowerCase();
          var match = !query || title.indexOf(query) !== -1;
          line.classList.toggle('is-filtered-out', !match);
          if (match) visible += 1;
        });
        if (searchEmpty) searchEmpty.classList.toggle('hidden', visible > 0);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    const sortSelect = document.getElementById('collection-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const sortValue = this.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    }

    (function applyMetafieldFiltersAndLoadMore() {
      const urlParams = new URLSearchParams(window.location.search);
      const inStock = urlParams.get('inStock') === '1';
      const activeFinishes = urlParams.getAll('finish').map(v => (v || '').trim()).filter(Boolean);
      const activeSizes = urlParams.getAll('size').map(v => (v || '').trim()).filter(Boolean);
      const activeColours = urlParams.getAll('colour').map(v => (v || '').trim()).filter(Boolean);

      const hasAnyFilter = inStock || activeFinishes.length > 0 || activeSizes.length > 0 || activeColours.length > 0;

      const grid = document.querySelector('.collection-products');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('.product-card'));
      const loadMoreBtn = document.getElementById('collection-load-more');
      if (cards.length === 0) {
        if (loadMoreBtn) loadMoreBtn.style.display = 'none';
        return;
      }

      const countEl = document.getElementById('collection-showing-count');
      const noteEl = document.getElementById('collection-pagination-note');
      const nextPageLink = document.getElementById('collection-next-page-link');
      const pageSize = Number(loadMoreBtn && loadMoreBtn.getAttribute('data-page-size')) || 12;

      const productById = new Map();
      if (hasAnyFilter) {
        const dataEls = document.querySelectorAll('[data-collection-metafield-data]');
        dataEls.forEach((dataEl) => {
          try {
            const products = JSON.parse(dataEl.textContent || '[]');
            products.forEach((product) => {
              if (product && product.id != null) {
                productById.set(String(product.id), product);
              }
            });
          } catch (e) {
            console.error('Failed to parse collection metafield data:', e);
          }
        });
      }

      // Helper to normalize metafield values into a clean string array.
      function normalizeValues(value) {
        if (Array.isArray(value)) return value.map(v => String(v).trim()).filter(Boolean);
        if (value == null) return [];
        const single = String(value).trim();
        return single ? [single] : [];
      }

      function matchesFilters(card) {
        if (!hasAnyFilter) return true;

        const productId = card.getAttribute('data-product-id');
        const product = productById.get(String(productId));

        if (!product) return false;

        let matches = true;

        if (inStock) {
          const stockStatuses = normalizeValues(product.stock_status);
          const isComingSoon = stockStatuses.includes('Coming Soon');
          matches = product.available === true && !isComingSoon;
        }

        if (matches && activeFinishes.length > 0) {
          const values = normalizeValues(product.finish);
          matches = values.some(v => activeFinishes.includes(v));
        }

        if (matches && activeSizes.length > 0) {
          const values = normalizeValues(product.size);
          matches = values.some(v => activeSizes.includes(v));
        }

        if (matches && activeColours.length > 0) {
          const values = normalizeValues(product.colour);
          matches = values.some(v => activeColours.includes(v));
        }

        return matches;
      }

      const matchingCards = cards.filter(matchesFilters);
      let shownCount = Math.min(pageSize, matchingCards.length);

      function renderVisibleCards() {
        cards.forEach((card) => {
          card.style.display = 'none';
        });

        for (let i = 0; i < shownCount; i += 1) {
          matchingCards[i].style.display = '';
        }

        if (countEl) {
          countEl.textContent = `Showing ${shownCount} of ${matchingCards.length} products`;
        }

        const hasMore = shownCount < matchingCards.length;

        if (loadMoreBtn) {
          loadMoreBtn.style.display = hasMore ? '' : 'none';
          loadMoreBtn.disabled = !hasMore;
        }

        if (noteEl) {
          noteEl.style.display = hasMore ? 'none' : '';
          noteEl.textContent = matchingCards.length === 0 ? 'No products match your filters' : '';
        }

        if (nextPageLink) {
          nextPageLink.style.display = !hasMore && matchingCards.length > 0 ? '' : 'none';
        }
      }

      renderVisibleCards();

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function() {
          shownCount = Math.min(shownCount + pageSize, matchingCards.length);
          renderVisibleCards();
        });
      }


    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.collections-section');
    
    sections.forEach(function(section) {
      // Set active state based on URL
      function updateActiveState() {
        const urlParams = new URLSearchParams(window.location.search);
        const activeCategory = urlParams.get('category');
        const currentPath = window.location.pathname;
        const pathHandle = currentPath.split('/').filter(Boolean).pop();
        
        const buttons = section.querySelectorAll('.collection-card__button');
        buttons.forEach(function(button) {
          const handle = button.getAttribute('data-collection-handle');
          const isActive = activeCategory === handle || pathHandle === handle;
          if (isActive) {
            button.classList.add('collection-card__button--active');
          } else {
            button.classList.remove('collection-card__button--active');
          }
        });
      }

      updateActiveState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header = document.querySelector('.header');
    if (!header) return;

    // Mobile Menu
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
    const mobileMenuCloseBtns = header.querySelectorAll('[data-mobile-menu-close]');

    function openMobileMenu() {
      mobileMenu.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
      mobileMenu.removeAttribute('data-open');
      document.body.style.overflow = '';
    }

    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener('click', openMobileMenu);
      mobileMenuToggle.addEventListener('click', function() {
        this.setAttribute('aria-expanded', 'true');
      });
    }

    mobileMenuCloseBtns.forEach(btn => {
      btn.addEventListener('click', closeMobileMenu);
    });

    // Mobile Dropdowns
    const mobileDropdownToggles = header.querySelectorAll('[data-mobile-dropdown-toggle]');
    mobileDropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const dropdownId = this.getAttribute('data-mobile-dropdown-toggle');
        const dropdown = header.querySelector(`[data-mobile-dropdown="${dropdownId}"]`);
        const container = dropdown?.closest('.header__mobile-dropdown');
        
        if (container?.hasAttribute('data-open')) {
          container.removeAttribute('data-open');
        } else {
          // Close other dropdowns
          header.querySelectorAll('.header__mobile-dropdown[data-open]').forEach(d => {
            d.removeAttribute('data-open');
          });
          container?.setAttribute('data-open', '');
        }
      });
    });

    // Desktop Dropdowns
    const dropdownContainers = header.querySelectorAll('[data-dropdown-container]');
    dropdownContainers.forEach(container => {
      const toggle = container.querySelector('[data-dropdown-toggle]');
      const dropdown = container.querySelector('[data-dropdown]');
      
      container.addEventListener('mouseenter', function() {
        this.setAttribute('data-open', '');
      });
      
      container.addEventListener('mouseleave', function() {
        this.removeAttribute('data-open');
      });

      if (toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          if (container.hasAttribute('data-open')) {
            container.removeAttribute('data-open');
          } else {
            dropdownContainers.forEach(c => c.removeAttribute('data-open'));
            container.setAttribute('data-open', '');
          }
        });
      }
    });

    // Click outside to close dropdowns
    document.addEventListener('mousedown', function(e) {
      if (!e.target.closest('[data-dropdown-container]')) {
        dropdownContainers.forEach(c => c.removeAttribute('data-open'));
      }
    });

    // Search Popup
    const searchPopup = header.querySelector('[data-search-popup]');
    const searchToggleBtns = header.querySelectorAll('[data-search-toggle]');
    const searchCloseBtns = header.querySelectorAll('[data-search-close]');
    const searchInput = header.querySelector('[data-search-input]');

    if (!searchPopup) {
      console.error('Search popup element not found. Available elements:', header.querySelectorAll('[data-search]'));
    }

    function openSearch(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!searchPopup) {
        console.error('Cannot open search: popup element not found');
        return;
      }
      try {
        searchPopup.setAttribute('data-open', '');
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      } catch (error) {
        console.error('Error opening search:', error);
      }
    }

    function closeSearch(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (searchPopup) {
        searchPopup.removeAttribute('data-open');
        document.body.style.overflow = '';
        if (searchInput) searchInput.value = '';
        const suggestionsContainer = header.querySelector('[data-search-suggestions]');
        if (suggestionsContainer) {
          suggestionsContainer.removeAttribute('data-active');
          suggestionsContainer.removeAttribute('data-scrollable');
          suggestionsContainer.innerHTML = '';
        }
      }
    }

    if (searchToggleBtns && searchToggleBtns.length > 0) {
      searchToggleBtns.forEach(btn => {
        btn.addEventListener('click', openSearch);
      });
    } else {
      console.warn('No search toggle buttons found');
    }

    if (searchCloseBtns && searchCloseBtns.length > 0) {
      searchCloseBtns.forEach(btn => {
        btn.addEventListener('click', closeSearch);
      });
    }

    // Search Suggestions - wrapped in try-catch to prevent errors from breaking modal
    let suggestionsContainer = null;
    let searchUrl = '/search';
    let searchTimeout = null;
    let currentSearchController = null;
    
    try {
      suggestionsContainer = header.querySelector('[data-search-suggestions]');
      const searchConfigScript = header.querySelector('[data-search-config]');
      if (searchConfigScript) {
        const searchConfig = JSON.parse(searchConfigScript.textContent);
        if (searchConfig && searchConfig.searchUrl) {
          searchUrl = searchConfig.searchUrl;
        }
      }
    } catch (e) {
      console.warn('Error initializing search suggestions:', e);
      suggestionsContainer = null;
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function buildProductSearchUrl(query) {
      const separator = searchUrl.includes('?') ? '&' : '?';
      return `${searchUrl}${separator}q=${encodeURIComponent(query)}&type=product`;
    }

    function renderSuggestions(suggestions, query) {
      if (!suggestionsContainer) return;

      if (!query || query.trim().length === 0) {
        suggestionsContainer.removeAttribute('data-active');
        suggestionsContainer.removeAttribute('data-scrollable');
        suggestionsContainer.innerHTML = '';
        return;
      }

      if (suggestions.length === 0) {
        suggestionsContainer.setAttribute('data-active', '');
        suggestionsContainer.removeAttribute('data-scrollable');
        suggestionsContainer.innerHTML = `
          <p class="header__search-suggestions-empty">No matches yet.</p>
        `;
        return;
      }

      suggestionsContainer.setAttribute('data-active', '');
      suggestionsContainer.setAttribute('data-scrollable', '');

      const suggestionsHTML = suggestions.map(product => {
        const productUrl = product.url || `/products/${product.handle || ''}`;
        const productTitle = escapeHtml(product.title || 'Untitled Product');
        const productSku = escapeHtml(product.sku || '—');
        
        return `
          <button
            type="button"
            class="header__search-suggestion-item"
            data-product-url="${escapeHtml(productUrl)}"
          >
            <p class="header__search-suggestion-title">${productTitle}</p>
            <p class="header__search-suggestion-sku">SKU: ${productSku}</p>
          </button>
        `;
      }).join('');

      const viewAllHTML = `
        <button
          type="button"
          class="header__search-suggestion-view-all"
          data-search-query="${escapeHtml(query)}"
        >
          View all results
        </button>
      `;

      suggestionsContainer.innerHTML = `
        <p class="header__search-suggestions-label">Suggestions:</p>
        <div class="header__search-suggestions-list">
          ${suggestionsHTML}
          ${viewAllHTML}
        </div>
      `;

      // Add click handlers
      suggestionsContainer.querySelectorAll('[data-product-url]').forEach(btn => {
        btn.addEventListener('click', function() {
          const url = this.getAttribute('data-product-url');
          closeSearch();
          window.location.href = url;
        });
      });

      const viewAllBtn = suggestionsContainer.querySelector('[data-search-query]');
      if (viewAllBtn) {
        viewAllBtn.addEventListener('click', function() {
          const query = this.getAttribute('data-search-query');
          closeSearch();
          window.location.href = buildProductSearchUrl(query);
        });
      }
    }

    async function fetchSuggestions(query) {
      // Cancel previous request if still pending
      if (currentSearchController) {
        currentSearchController.abort();
      }

      if (!query || query.trim().length === 0) {
        renderSuggestions([], '');
        return;
      }

      currentSearchController = new AbortController();
      const normalizedQuery = query.trim().toLowerCase();

      try {
        let products = [];
        let allProducts = [];

        // Strategy 1: Try to get more products from search API (increase limit to get more results for filtering)
        // Also try multiple search variations to catch more results
        const searchQueries = [
          query, // Full query
          query.split(/\s+/).slice(0, 2).join(' '), // First 2 words
          query.split(/\s+/)[0], // First word only
        ].filter((q, i, arr) => arr.indexOf(q) === i); // Remove duplicates

        for (const searchQuery of searchQueries) {
          if (allProducts.length >= 50) break; // Already have enough

          try {
            const searchResponse = await fetch(
              `${searchUrl}.json?q=${encodeURIComponent(searchQuery)}&type=product&limit=50`,
              {
                signal: currentSearchController.signal,
                headers: {
                  'Accept': 'application/json'
                }
              }
            );

            if (searchResponse.ok) {
              // Check if response is actually JSON
              const contentType = searchResponse.headers.get('content-type');
              if (!contentType || !contentType.includes('application/json')) {
                console.warn('Search API returned non-JSON response');
                continue;
              }

              let searchData;
              try {
                const text = await searchResponse.text();
                // Check if response starts with HTML (error page)
                if (text.trim().startsWith('<!')) {
                  console.warn('Search API returned HTML instead of JSON');
                  continue;
                }
                searchData = JSON.parse(text);
              } catch (parseError) {
                console.warn('Failed to parse search API response as JSON:', parseError);
                continue;
              }
              // Handle different response structures
              const results = searchData.results || searchData.products || [];
              
              if (!Array.isArray(results)) {
                console.warn('Search API results is not an array:', results);
                continue;
              }

              const newProducts = results.map(item => {
                // Handle different product object structures
                const productTitle = item.title || item.product_title || '';
                const productHandle = item.handle || item.product_handle || '';
                const productUrl = item.url || `/products/${productHandle}`;
                
                // Try multiple ways to extract SKU
                let productSku = '';
                
                // Check variants array
                if (item.variants && Array.isArray(item.variants) && item.variants.length > 0) {
                  // Try first variant
                  productSku = item.variants[0].sku || '';
                  // If first variant has no SKU, try to find one that does
                  if (!productSku) {
                    const variantWithSku = item.variants.find(v => v.sku);
                    if (variantWithSku) {
                      productSku = variantWithSku.sku;
                    }
                  }
                }
                
                // Check single variant object
                if (!productSku && item.variant) {
                  productSku = item.variant.sku || '';
                }
                
                // Check direct SKU property
                if (!productSku) {
                  productSku = item.sku || '';
                }
                
                // Check first_available_variant
                if (!productSku && item.first_available_variant) {
                  productSku = item.first_available_variant.sku || '';
                }

                return {
                  title: productTitle,
                  url: productUrl,
                  handle: productHandle,
                  sku: productSku,
                  id: item.id || item.product_id || null
                };
              });

              // Merge with existing products, avoiding duplicates
              newProducts.forEach(newProduct => {
                if (!allProducts.find(p => p.handle === newProduct.handle || p.url === newProduct.url)) {
                  allProducts.push(newProduct);
                }
              });
            }
          } catch (e) {
            // Only log if it's not an abort error
            if (e.name !== 'AbortError') {
              console.warn('Search API error:', e);
            }
          }
        }

        // Strategy 2: Try search suggestions API as fallback
        if (allProducts.length === 0) {
          for (const searchQuery of searchQueries) {
            if (allProducts.length >= 50) break;

            try {
              const suggestResponse = await fetch(
                `/search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product&resources[limit]=50`,
                {
                  signal: currentSearchController.signal,
                  headers: {
                    'Accept': 'application/json'
                  }
                }
              );

              if (suggestResponse.ok) {
                // Check if response is actually JSON
                const contentType = suggestResponse.headers.get('content-type');
                if (!contentType || !contentType.includes('application/json')) {
                  console.warn('Suggest API returned non-JSON response');
                  continue;
                }

                let suggestData;
                try {
                  const text = await suggestResponse.text();
                  // Check if response starts with HTML (error page)
                  if (text.trim().startsWith('<!')) {
                    console.warn('Suggest API returned HTML instead of JSON');
                    continue;
                  }
                  suggestData = JSON.parse(text);
                } catch (parseError) {
                  console.warn('Failed to parse suggest API response as JSON:', parseError);
                  continue;
                }
                
                // Handle different response structures for suggest API
                let results = [];
                if (suggestData.resources) {
                  // Check if resources.results exists and is an array
                  if (Array.isArray(suggestData.resources.results)) {
                    results = suggestData.resources.results;
                  } else if (suggestData.resources.results && Array.isArray(suggestData.resources.results.products)) {
                    results = suggestData.resources.results.products;
                  } else if (Array.isArray(suggestData.resources.products)) {
                    results = suggestData.resources.products;
                  }
                } else if (Array.isArray(suggestData.results)) {
                  results = suggestData.results;
                } else if (Array.isArray(suggestData.products)) {
                  results = suggestData.products;
                }

                if (results.length > 0) {
                  const newProducts = results.map(item => {
                    // Try multiple ways to extract SKU from suggest API
                    let productSku = '';
                    
                    if (item.variants && Array.isArray(item.variants) && item.variants.length > 0) {
                      productSku = item.variants[0].sku || '';
                      if (!productSku) {
                        const variantWithSku = item.variants.find(v => v.sku);
                        if (variantWithSku) productSku = variantWithSku.sku;
                      }
                    }
                    
                    if (!productSku && item.variant) {
                      productSku = item.variant.sku || '';
                    }
                    
                    if (!productSku) {
                      productSku = item.sku || '';
                    }
                    
                    return {
                      title: item.title || '',
                      url: item.url || `/products/${item.handle || ''}`,
                      handle: item.handle || '',
                      sku: productSku,
                      id: item.id || item.product_id || null
                    };
                  });

                  // Merge with existing products, avoiding duplicates
                  newProducts.forEach(newProduct => {
                    if (!allProducts.find(p => p.handle === newProduct.handle || p.url === newProduct.url)) {
                      allProducts.push(newProduct);
                    }
                  });
                }
              }
            } catch (e) {
              // Only log if it's not an abort error
              if (e.name !== 'AbortError') {
                console.warn('Suggest API error:', e);
              }
            }
          }
        }

        // Client-side filtering: Filter products similar to React version
        // Match against title, SKU, handle, and other fields
        if (allProducts.length > 0) {
          // Create a comprehensive search string from all product fields
          products = allProducts.map(product => {
            const searchFields = [
              product.title,
              product.sku,
              product.handle,
              product.title?.replace(/[^\w\s]/g, ' '), // Remove special chars
            ]
              .filter(Boolean)
              .map(v => String(v).toLowerCase().trim())
              .join(' ');

            return {
              ...product,
              _searchFields: searchFields
            };
          });

          // Filter products based on query matching
          const queryWords = normalizedQuery.split(/\s+/).filter(w => w.length > 0);
          
          // Score products based on how well they match
          products = products
            .map(product => {
              let score = 0;
              const searchFields = product._searchFields;

              // Exact phrase match gets highest score
              if (searchFields.includes(normalizedQuery)) {
                score += 100;
              }

              // Check each query word
              queryWords.forEach(word => {
                if (word.length > 0) {
                  // Exact word match
                  if (searchFields.includes(' ' + word + ' ') || 
                      searchFields.startsWith(word + ' ') || 
                      searchFields.endsWith(' ' + word)) {
                    score += 50;
                  }
                  // Partial word match (word contains or is contained)
                  else if (searchFields.includes(word)) {
                    score += 25;
                  }
                  // Check if any word in searchFields contains the query word
                  else {
                    const fields = searchFields.split(/\s+/);
                    if (fields.some(field => field.includes(word) || word.includes(field))) {
                      score += 10;
                    }
                  }
                }
              });

              return { ...product, _score: score };
            })
            .filter(product => product._score > 0) // Only keep products with some match
            .sort((a, b) => b._score - a._score) // Sort by score descending
            .slice(0, 6) // Limit to 6 results
            .map(({ _searchFields, _score, ...product }) => product); // Remove helper fields

          // If still no results, try more lenient matching
          if (products.length === 0 && queryWords.length > 1) {
            const significantWords = queryWords
              .filter(w => w.length > 2) // Only words longer than 2 characters
              .slice(0, 2); // Try first 2 significant words
            
            if (significantWords.length > 0) {
              products = allProducts.filter(product => {
                const searchFields = [
                  product.title,
                  product.sku,
                  product.handle,
                ]
                  .filter(Boolean)
                  .map(v => String(v).toLowerCase())
                  .join(' ');

                // Match if any significant word appears
                return significantWords.some(word => searchFields.includes(word));
              }).slice(0, 6);
            }
          }
        }
        
        // Render suggestions first (with or without SKU)
        renderSuggestions(products, query);
        
        // Fetch SKU for products that don't have it (only for products we'll display)
        // This will update the display once SKU is fetched
        const productsNeedingSku = products.filter(p => !p.sku && p.handle);
        
        if (productsNeedingSku.length > 0) {
          // Fetch SKU data in parallel for products missing it
          const skuPromises = productsNeedingSku.map(async (product) => {
            try {
              const productResponse = await fetch(
                `/products/${product.handle}.json`,
                {
                  signal: currentSearchController.signal,
                  headers: {
                    'Accept': 'application/json'
                  }
                }
              );
              
              if (productResponse.ok) {
                const contentType = productResponse.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                  const text = await productResponse.text();
                  if (!text.trim().startsWith('<!')) {
                    const productData = JSON.parse(text);
                    const productObj = productData.product || productData;
                    
                    if (productObj.variants && Array.isArray(productObj.variants) && productObj.variants.length > 0) {
                      const firstVariant = productObj.variants[0];
                      if (firstVariant && firstVariant.sku) {
                        return { handle: product.handle, sku: firstVariant.sku };
                      }
                    }
                  }
                }
              }
            } catch (e) {
              // Silently fail - SKU is optional
            }
            return null;
          });
          
          Promise.all(skuPromises).then(skuResults => {
            let updated = false;
            skuResults.forEach(result => {
              if (result) {
                const product = products.find(p => p.handle === result.handle);
                if (product && !product.sku) {
                  product.sku = result.sku;
                  updated = true;
                }
              }
            });
            
            // Re-render if any SKUs were updated
            if (updated) {
              renderSuggestions(products, query);
            }
          });
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          return; // Request was cancelled, ignore
        }
        console.error('Error fetching search suggestions:', error);
        renderSuggestions([], query);
      } finally {
        currentSearchController = null;
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        try {
          const query = this.value.trim();

          // Clear previous timeout
          if (searchTimeout) {
            clearTimeout(searchTimeout);
          }

          // Clear suggestions immediately if input is empty
          if (query.length === 0) {
            if (suggestionsContainer) {
              suggestionsContainer.removeAttribute('data-active');
              suggestionsContainer.removeAttribute('data-scrollable');
              suggestionsContainer.innerHTML = '';
            }
            return;
          }

          // Debounce search requests
          searchTimeout = setTimeout(() => {
            try {
              fetchSuggestions(query);
            } catch (e) {
              console.error('Error in fetchSuggestions:', e);
            }
          }, 300);
        } catch (e) {
          console.error('Error in search input handler:', e);
        }
      });
    }

    // Escape key handlers
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (mobileMenu?.hasAttribute('data-open')) {
          closeMobileMenu();
          mobileMenuToggle?.setAttribute('aria-expanded', 'false');
        }
        if (searchPopup?.hasAttribute('data-open')) {
          closeSearch();
        }
      }
    });

    // Prevent body scroll when menus are open
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-open') {
          const isOpen = mobileMenu?.hasAttribute('data-open') || searchPopup?.hasAttribute('data-open');
          document.body.style.overflow = isOpen ? 'hidden' : '';
        }
      });
    });

    if (mobileMenu) observer.observe(mobileMenu, { attributes: true });
    if (searchPopup) observer.observe(searchPopup, { attributes: true });

    // Wishlist count update
    function updateWishlistCount() {
      try {
        const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        const count = Array.isArray(wishlist) ? wishlist.length : 0;
        const badges = header.querySelectorAll('[data-wishlist-count]');
        
        badges.forEach(badge => {
          if (count > 0) {
            badge.textContent = count;
            badge.style.display = 'grid';
          } else {
            badge.style.display = 'none';
          }
        });
      } catch (e) {
        console.error('Error updating wishlist count:', e);
      }
    }

    // Update wishlist count on load
    updateWishlistCount();

    // Listen for wishlist changes (from other parts of the site)
    window.addEventListener('storage', function(e) {
      if (e.key === 'wishlist') {
        updateWishlistCount();
      }
    });

    // Also listen for custom events (for same-tab updates)
    window.addEventListener('wishlistUpdated', updateWishlistCount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-react"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const rootElement = document.querySelector('[id^="instagram-react-"]');
    const dataElement = document.querySelector('[id^="instagram-react-data-"]');
    if (!rootElement || !dataElement) return;

    const props = JSON.parse(dataElement.textContent);

    // Wait for React and ReactDOM to be available
    function initInstagramReact() {
      if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
        setTimeout(initInstagramReact, 100);
        return;
      }

      const { createElement: h } = React;

      // Instagram Icon Component
      const InstagramIcon = ({ size = 20 }) => 
        h('svg', {
          width: size,
          height: size,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: '2'
        }, [
          h('rect', { x: '2', y: '2', width: '20', height: '20', rx: '5', ry: '5' }),
          h('path', { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' }),
          h('line', { x1: '17.5', y1: '6.5', x2: '17.51', y2: '6.5' })
        ]);

      // Instagram Section Component
      const Instagram = ({ instagramUrl, buttonText, backgroundImage }) => {
        const backgroundStyle = backgroundImage 
          ? { backgroundImage: `url(${backgroundImage})` }
          : { backgroundImage: 'url("/images/instagramfeed.png")' };

        return h('section', {
          className: 'w-full bg-cover bg-center h-48 flex justify-center items-center cursor-pointer',
          style: backgroundStyle,
          onClick: () => window.open(instagramUrl, '_blank')
        }, 
          h('button', {
            className: 'bg-blue-button text-white text-lg font-medium py-4 px-8 rounded flex justify-center items-center gap-2 cursor-pointer'
          }, [
            h(InstagramIcon, { size: 20 }),
            ' ',
            buttonText
          ])
        );
      };

      // Render the component
      ReactDOM.render(h(Instagram, props), rootElement);
    }

    // Load React and ReactDOM if not already loaded
    if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
      const reactScript = document.createElement('script');
      reactScript.src = 'https://unpkg.com/react@18/umd/react.production.min.js';
      reactScript.crossOrigin = '';
      reactScript.onload = function() {
        const reactDOMScript = document.createElement('script');
        reactDOMScript.src = 'https://unpkg.com/react-dom@18/umd/react-dom.production.min.js';
        reactDOMScript.crossOrigin = '';
        reactDOMScript.onload = initInstagramReact;
        document.head.appendChild(reactDOMScript);
      };
      document.head.appendChild(reactScript);
    } else {
      initInstagramReact();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-subscribe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (document.documentElement.dataset.newsletterSubscribeBound === 'true') return;
    document.documentElement.dataset.newsletterSubscribeBound = 'true';

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-newsletter-subscribe]')) return;

      event.preventDefault();
      if (form.dataset.submitting === 'true') return;

      var message = form.querySelector('[data-newsletter-message]');
      var button = form.querySelector('[type="submit"]');
      var emailInput = form.querySelector('input[name="email"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var buttonLabel = button ? button.textContent : '';

      function showMessage(state, text) {
        if (!message) return;
        message.hidden = false;
        message.dataset.state = state;
        message.textContent = text;
      }

      if (!email || (emailInput && !emailInput.checkValidity())) {
        if (emailInput) emailInput.reportValidity();
        return;
      }

      form.dataset.submitting = 'true';
      if (message) message.hidden = true;
      if (button) {
        button.disabled = true;
        button.textContent = form.dataset.submittingMessage || buttonLabel;
      }

      fetch('/apps/quotes/subscription', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      })
        .then(function (response) {
          if (response.status === 409) throw new Error('Already subscribed');
          if (!response.ok) throw new Error('Request failed');
          var type = response.headers.get('content-type') || '';
          if (type.indexOf('application/json') === -1) return null;
          return response.json().catch(function () {
            return null;
          });
        })
        .then(function (body) {
          if (body && (body.success === false || body.error)) {
            throw new Error('Rejected');
          }
          showMessage('success', form.dataset.successMessage);
          form.reset();
        })
        .catch(function (error) {
          if (error && error.message === 'Already subscribed') {
            showMessage('error', form.dataset.alreadySubscribedMessage);
            return;
          }
          showMessage('error', form.dataset.errorMessage);
        })
        .then(function () {
          form.dataset.submitting = 'false';
          if (button) {
            button.disabled = false;
            button.textContent = buttonLabel;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    // Image gallery functionality
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    const mainImage = document.getElementById('main-product-image');
    
    if (thumbnails.length > 0 && mainImage) {
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', function() {
          // Remove active class from all thumbnails
          thumbnails.forEach(t => {
            t.classList.remove('active');
            t.style.borderColor = '#d1d5db';
            t.style.opacity = '0.5';
          });
          
          // Add active class to clicked thumbnail
          this.classList.add('active');
          this.style.borderColor = '#0b2848';
          this.style.opacity = '1';
          
          // Update main image - get the full-size image URL from data attribute
          const imageUrl = this.dataset.imageUrl;
          if (imageUrl) {
            mainImage.src = imageUrl;
            mainImage.srcset = '';
          }
        });
      });
      
      // Set first thumbnail as active if not already set
      if (thumbnails[0] && !thumbnails[0].classList.contains('active')) {
        thumbnails[0].classList.add('active');
        thumbnails[0].style.borderColor = '#0b2848';
        thumbnails[0].style.opacity = '1';
      }
    }

    // Tab functionality
    const tabButtons = document.querySelectorAll('.product-tab-btn');
    const tabContents = document.querySelectorAll('.product-tab-content');
    
    tabButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const targetTab = this.dataset.tab;
        
        // Update button states
        tabButtons.forEach(b => {
          b.classList.remove('active');
          b.classList.add('text-gray');
          b.classList.remove('text-dark', 'border-b-2', 'border-dark');
        });
        this.classList.add('active', 'text-dark', 'border-b-2', 'border-dark');
        this.classList.remove('text-gray');
        
        // Update content visibility
        tabContents.forEach(content => {
          content.classList.add('hidden');
        });
        const targetContent = document.querySelector(`[data-tab-content="${targetTab}"]`);
        if (targetContent) {
          targetContent.classList.remove('hidden');
        }
      });
    });

    // Recent sold count is now handled server-side with real data

    // Wishlist functionality (mirrors product-card behavior)
    const wishlistBtn = document.querySelector('.product-wishlist-btn');
    const productPrice = parseInt(wishlistBtn.getAttribute('data-product-price') || '0');
    if (wishlistBtn) {
      const productId = wishlistBtn.getAttribute('data-product-id');
      const productTitle = wishlistBtn.getAttribute('data-product-title');
      const productHandle = wishlistBtn.getAttribute('data-product-handle');
      const productUrl = wishlistBtn.getAttribute('data-product-url') || window.location.pathname;
      const productComparePrice = parseInt(wishlistBtn.getAttribute('data-product-compare-price') || '0');
      const productImage = wishlistBtn.getAttribute('data-product-image');
      const productImageSecondary = wishlistBtn.getAttribute('data-product-image-secondary') || productImage;
      const productVariantId = "{{ current_variant.id }}";

      // Initialize button state from localStorage
      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      const isInWishlist = wishlist.includes(productId);
      if (isInWishlist) {
        wishlistBtn.classList.add('active');
        const icon = wishlistBtn.querySelector('.product-wishlist-icon');
        if (icon) {
          icon.setAttribute('fill', 'currentColor');
        }
      }

      wishlistBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        const isActive = this.classList.contains('active');
        const icon = this.querySelector('.product-wishlist-icon');

        if (isActive) {
          // Remove from wishlist
          wishlist = wishlist.filter(id => id !== productId);
          this.classList.remove('active');
          if (icon) {
            icon.setAttribute('fill', 'none');
          }
          localStorage.removeItem(`product_${productId}`);
        } else {
          // Add to wishlist
          if (!wishlist.includes(productId)) {
            wishlist.push(productId);
          }
          this.classList.add('active');
          if (icon) {
            icon.setAttribute('fill', 'currentColor');
          }

          // Store product data in localStorage for wishlist page
          const productData = {
            id: productId,
            title: productTitle,
            handle: productHandle,
            url: productUrl,
            featuredImage: productImage,
            images: [productImage, productImageSecondary].filter(Boolean),
            price: productPrice,
            compareAtPrice: productComparePrice > productPrice ? productComparePrice : null,
            variantId: productVariantId
          };
          localStorage.setItem(`product_${productId}`, JSON.stringify(productData));
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlist));

        // Notify other components (e.g. wishlist drawer/page)
        window.dispatchEvent(new Event('wishlist-updated'));
      });
    }

    // Share functionality
    const shareBtn = document.querySelector('.product-share-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', async function() {
        const shareData = {
          title: this.dataset.productTitle || '',
          text: this.dataset.productDescription || '',
          url: window.location.href
        };
        
        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(shareData.url);
            alert('Link copied to clipboard!');
          } else {
            prompt('Copy this link:', shareData.url);
          }
        } catch (e) {
          console.error('Error sharing:', e);
        }
      });
    }

    // Buy Now functionality
    const buyNowBtn = document.querySelector('.product-buy-now');
    const productForm = document.getElementById('product-form');
    if (buyNowBtn && productForm) {
      buyNowBtn.addEventListener('click', function() {
        productForm.submit();
        // Redirect to cart after submission
        setTimeout(() => {
          window.location.href = '/cart';
        }, 100);
      });
    }

    // Compare functionality (placeholder)
    const compareBtn = document.querySelector('.product-compare-btn');
    if (compareBtn) {
      compareBtn.addEventListener('click', function() {
        alert('Compare functionality coming soon!');
      });
    }

    // Box quantity selector
    const boxQuantitySelector = document.querySelector('.box-quantity-selector');
    const boxQuantityValue = document.querySelector('[data-box-quantity-value]');
    const squareMetersValue = document.querySelector('[data-square-meters-value]');
    const minusBoxBtn = document.querySelector('.box-quantity-selector__btn--minus');
    const plusBoxBtn = document.querySelector('.box-quantity-selector__btn--plus');
    const quantityInput = document.querySelector('.product-quantity');
    const stockAlert = document.querySelector('[data-stock-alert]');
    const stockCount = parseInt(boxQuantitySelector?.dataset.stockCount, 10) || 0;

    let boxQuantity = 1;

    function formatSquareMeters(value) {
      return value.toFixed(2).replace('.', ',');
    }

    function showStockAlert() {
      if (!stockAlert) return;
      const boxesLeft = stockAlert.querySelector('[data-boxes-left]');
      if (boxesLeft) boxesLeft.textContent = stockCount;
      stockAlert.classList.remove('hidden');
    }

    function hideStockAlert() {
      if (stockAlert) stockAlert.classList.add('hidden');
    }

    function setBoxQuantity(value) {
      const requested = parseInt(value, 10);
      const quantity = isNaN(requested) ? 1 : requested;

      if (stockCount > 0 && quantity > stockCount) {
        boxQuantity = stockCount;
        showStockAlert();
      } else {
        boxQuantity = Math.max(1, quantity);
        hideStockAlert();
      }

      updateBoxQuantityDisplay();
    }

    function updateBoxQuantityDisplay() {
      if (!boxQuantitySelector) return;

      const packSize = parseFloat(boxQuantitySelector.dataset.packSize) || 1;

      if (boxQuantityValue) boxQuantityValue.value = boxQuantity;
      if (squareMetersValue) squareMetersValue.textContent = formatSquareMeters(boxQuantity * packSize);
      if (quantityInput) quantityInput.value = boxQuantity;
      if (minusBoxBtn) minusBoxBtn.disabled = boxQuantity <= 1;
    }

    if (minusBoxBtn) {
      minusBoxBtn.addEventListener('click', function() {
        setBoxQuantity(boxQuantity - 1);
      });
    }

    if (plusBoxBtn) {
      plusBoxBtn.addEventListener('click', function() {
        setBoxQuantity(boxQuantity + 1);
      });
    }

    if (boxQuantityValue) {
      boxQuantityValue.addEventListener('input', function() {
        const raw = this.value.replace(/\D/g, '');
        if (this.value !== raw) this.value = raw;
        if (raw === '') return;
        setBoxQuantity(raw);
      });

      boxQuantityValue.addEventListener('blur', function() {
        setBoxQuantity(this.value);
      });

      boxQuantityValue.addEventListener('keydown', function(e) {
        if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
          e.preventDefault();
        }
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        if (stockCount > 0 && boxQuantity > stockCount) {
          e.preventDefault();
          showStockAlert();
        }
      });
    }

    if (boxQuantitySelector) {
      updateBoxQuantityDisplay();
    }

    function setBoxQuantityFromCalculator(boxes) {
      setBoxQuantity(boxes);
    }

    // Quote Calculator
    const openQuoteBtn = document.getElementById('open-quote-calculator');
    const openQuoteBtns = document.querySelectorAll('[data-open-quote-calculator], #open-quote-calculator');
    const quoteModal = document.getElementById('quote-calculator-modal');
    const closeQuoteModal = document.getElementById('close-quote-modal');
    const cancelQuoteModal = document.getElementById('cancel-quote-modal');
    const calculateQuoteBtn = document.getElementById('calculate-quote-btn');
    const addToQuoteBtn = document.getElementById('add-to-quote-btn');
    const lengthInput = document.getElementById('quote-room-length');
    const widthInput = document.getElementById('quote-room-width');
    const quoteResults = document.getElementById('quote-results');
    const resultTotalArea = document.getElementById('result-total-area');
    const resultWastageArea = document.getElementById('result-wastage-area');
    const resultBoxes = document.getElementById('result-boxes');
    const priceBox = document.getElementById('price-box');
    const totalPriceBoxes = document.getElementById('total-price-box');
    const boxPrice = productPrice / 100;
    const packSize = parseFloat(
      (openQuoteBtn || boxQuantitySelector)?.dataset.packSize || '1'
    ) || 1;

    let calculatedBoxes = 0;

    function openModal() {
      quoteModal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      quoteModal.classList.add('hidden');
      document.body.style.overflow = '';
      // Reset state
      lengthInput.value = '';
      widthInput.value = '';
      quoteResults.classList.add('hidden');
      calculateQuoteBtn.disabled = true;
      calculatedBoxes = 0;
    }

    function updateCalculateBtn() {
      const hasLength = lengthInput.value && parseFloat(lengthInput.value) > 0;
      const hasWidth = widthInput.value && parseFloat(widthInput.value) > 0;
      calculateQuoteBtn.disabled = !(hasLength && hasWidth);
    }

    function calculateQuote() {
      const length = parseFloat(lengthInput.value);
      const width = parseFloat(widthInput.value);
      if (!length || !width || length <= 0 || width <= 0) return;

      const totalArea = length * width;
      const wastageArea = totalArea * 1.15;
      // calculatedBoxes = Math.ceil(wastageArea / packSize);

      calculatedBoxes = Math.ceil(wastageArea / packSize);

      resultTotalArea.textContent = totalArea.toFixed(2) + ' m²';
      resultWastageArea.textContent = wastageArea.toFixed(2) + ' m²';
      resultBoxes.textContent = calculatedBoxes;
      priceBox.textContent = `R ${boxPrice.toFixed(2)}`;
      totalPriceBoxes.textContent = `R ${(calculatedBoxes * boxPrice).toFixed(2)}`;
      quoteResults.classList.remove('hidden');
    }

    function addToQuote() {
      if (calculatedBoxes < 1) return;
      setBoxQuantityFromCalculator(calculatedBoxes);
      closeModal();
    }

    openQuoteBtns.forEach(function(btn) {
      btn.addEventListener('click', openModal);
    });
    if (closeQuoteModal) closeQuoteModal.addEventListener('click', closeModal);
    if (cancelQuoteModal) cancelQuoteModal.addEventListener('click', closeModal);
    if (calculateQuoteBtn) calculateQuoteBtn.addEventListener('click', calculateQuote);
    if (addToQuoteBtn) addToQuoteBtn.addEventListener('click', addToQuote);
    if (lengthInput) lengthInput.addEventListener('input', updateCalculateBtn);
    if (widthInput) widthInput.addEventListener('input', updateCalculateBtn);

    // Close modal on backdrop click
    if (quoteModal) {
      quoteModal.addEventListener('click', function(e) {
        if (e.target === quoteModal) closeModal();
      });
    }

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && quoteModal && !quoteModal.classList.contains('hidden')) {
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-react"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const rootElement = document.querySelector('[id^="wishlist-react-"]');
    const dataElement = document.querySelector('[id^="wishlist-react-data-"]');
    if (!rootElement || !dataElement) return;

    const props = JSON.parse(dataElement.textContent);

    // Wait for React and ReactDOM to be available
    function initWishlistReact() {
      if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
        setTimeout(initWishlistReact, 100);
        return;
      }

      const { createElement: h, useState, useEffect } = React;

      // Product Card Component
      const ProductCard = ({ product }) => {
        const [isHovered, setIsHovered] = useState(false);
        
        if (!product) {
          console.error('ProductCard received null product');
          return null;
        }
        
        const primaryImage = product.featuredImage || product.images?.[0] || '';
        const secondaryImage = product.images?.[1] || product.featuredImage || primaryImage;
        const hasSale = product.compareAtPrice && product.compareAtPrice > product.price;
        const salePrice = product.price || 0;
        const regularPrice = (product.compareAtPrice && product.compareAtPrice > product.price) ? product.compareAtPrice : product.price || 0;
        const productAvailable = typeof product.available === 'boolean' ? product.available : true;

        return h('div', {
          className: 'product-card group',
          'data-product-id': product.id,
          'data-product-url': product.url || `/products/${product.handle || ''}`,
          onClick: (e) => {
            // Navigate to product page if clicking on card (not buttons)
            if (!e.target.closest('button') && !e.target.closest('a')) {
              window.location.href = product.url || `/products/${product.handle || ''}`;
            }
          },
          style: { cursor: 'pointer' },
          onMouseEnter: () => setIsHovered(true),
          onMouseLeave: () => setIsHovered(false)
        }, [
          h('div', { className: 'product-card__image-wrapper' }, [
            !productAvailable ? h('div', { className: 'product-card__coming-soon-badge' }, 'Coming Soon') : null,
            primaryImage ? h('div', { className: 'product-card__image-container' }, [
              h('div', { className: 'product-card__shimmer' }),
              h('img', {
                className: 'product-card__image product-card__image--primary',
                src: primaryImage,
                alt: product.title || 'Product',
                loading: 'lazy',
                onError: (e) => {
                  e.target.style.display = 'none';
                }
              }),
              secondaryImage && secondaryImage !== primaryImage ? h('img', {
                className: 'product-card__image product-card__image--secondary',
                src: secondaryImage,
                alt: product.title || 'Product',
                loading: 'lazy',
                style: { opacity: isHovered ? 1 : 0 },
                onError: (e) => {
                  e.target.style.display = 'none';
                }
              }) : null
            ]) : h('div', { 
              className: 'product-card__image-container',
              style: { 
                backgroundColor: '#f3f3f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#999'
              }
            }, 'No Image'),
            h('div', { className: `product-card__actions${!productAvailable ? ' product-card__actions--single' : ''}` }, [
              productAvailable ? h('button', {
                type: 'button',
                className: 'product-card__action-btn',
                'data-action': 'add-to-cart',
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  // Add to cart logic
                  const form = document.createElement('form');
                  form.method = 'POST';
                  form.action = '/cart/add';
                  const input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = 'id';
                  input.value = product.variantId || product.variants?.[0]?.id;
                  form.appendChild(input);
                  document.body.appendChild(form);
                  form.submit();
                }
              }, h('svg', {
                className: 'product-card__icon',
                width: 18,
                height: 18,
                viewBox: '0 0 24 24',
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 2
              }, [
                h('path', { d: 'M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z' }),
                h('line', { x1: 3, y1: 6, x2: 21, y2: 6 }),
                h('path', { d: 'M16 10a4 4 0 0 1-8 0' })
              ])) : null,
              h('a', {
                href: product.url,
                className: 'product-card__action-btn',
                onClick: (e) => e.stopPropagation()
              }, h('svg', {
                className: 'product-card__icon',
                width: 18,
                height: 18,
                viewBox: '0 0 24 24',
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 2
              }, [
                h('path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
                h('circle', { cx: 12, cy: 12, r: 3 })
              ]))
            ]),
            h('button', {
              type: 'button',
              className: 'product-card__wishlist',
              'data-action': 'wishlist',
              onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                // Remove from wishlist
                let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
                wishlist = wishlist.filter(id => id !== product.id.toString());
                localStorage.setItem('wishlist', JSON.stringify(wishlist));
                // Trigger re-render
                window.dispatchEvent(new Event('wishlist-updated'));
              }
            }, h('svg', {
              className: 'product-card__wishlist-icon',
              width: 18,
              height: 18,
              viewBox: '0 0 24 24',
              fill: 'currentColor',
              stroke: 'currentColor',
              strokeWidth: 2
            }, h('path', { d: 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z' }))),
            hasSale && h('div', { className: 'product-card__badge' }, [
              h('span', { className: 'product-card__badge-text' }, 'Sale')
            ])
          ]),
          h('div', { className: 'product-card__info' }, [
            h('p', { className: 'product-card__title' }, product.title),
            h('div', { className: 'product-card__price-wrapper' }, [
              hasSale && h('span', {
                className: 'product-card__price product-card__price--compare'
              }, formatMoney(regularPrice)),
              h('span', {
                className: 'product-card__price product-card__price--current'
              }, formatMoney(salePrice) + ' m2')
            ])
          ])
        ]);
      };

      // Format money helper
      function formatMoney(cents) {
        return new Intl.NumberFormat('en-ZA', {
          style: 'currency',
          currency: 'ZAR'
        }).format(cents / 100);
      }

      // Hero Component
      const Hero = ({ homeLink, title, home }) => {
        return h('section', {
          className: 'h-[250px] lg:h-[300px] pt-10 pb-2 lg:pb-4 px-3 lg:px-12 flex flex-col justify-center items-center'
        }, [
          h('h1', {
            className: 'font-title text-4xl lg:text-7xl text-dark drop-shadow-lg text-center'
          }, title),
          h('div', {
            className: 'flex justify-center items-center gap-2 pt-4'
          }, [
            h('a', {
              href: homeLink,
              className: 'text-dark text-sm lg:text-lg leading-tight mb-2 drop-shadow text-center'
            }, home),
            h('span', {
              className: 'text-dark text-sm lg:text-lg leading-tight mb-2 drop-shadow text-center'
            }, '/'),
            h('a', {
              href: '#',
              className: 'text-dark text-sm lg:text-lg leading-tight mb-2 drop-shadow text-center'
            }, title)
          ])
        ]);
      };

      // Empty State Component
      const EmptyState = ({ empty, emptyDescription, goToShop }) => {
        return h('section', {
          className: 'w-full pb-8 lg:pb-14 px-3 lg:px-12'
        }, h('div', {
          className: 'w-full max-w-xl mx-auto bg-white rounded-xl border border-gray-200 p-6 text-center',
          style: { marginInline: 'auto' }
        }, [
          h('p', {
            className: 'text-lg font-medium text-dark'
          }, empty),
          h('p', {
            className: 'text-gray pt-2 pb-5'
          }, emptyDescription),
          h('a', {
            href: '/collections',
            className: 'inline-block mt-4 px-6 py-3 rounded-full font-medium text-white bg-blue hover:bg-blue-button transition-colors',
            style: { boxShadow: '4px 4px 0px 0px rgb(11,40,72)' }
          }, goToShop)
        ]));
      };

      // Fetch product data from localStorage or Shopify API
      async function fetchProducts(productIds) {
        if (!productIds || productIds.length === 0) {
          console.log('No product IDs in wishlist');
          return [];
        }

        const products = [];
        const missingIds = [];
        
        // First, try to get from localStorage
        productIds.forEach(id => {
          const stored = localStorage.getItem(`product_${id}`);
          if (stored) {
            try {
              const productData = JSON.parse(stored);
              console.log('Loaded product from localStorage:', productData);
              products.push(productData);
            } catch (e) {
              console.error(`Error parsing product data for ${id}:`, e);
              missingIds.push(id);
            }
          } else {
            console.warn(`Product data not found in localStorage for ID: ${id}`);
            missingIds.push(id);
          }
        });

        // If we have missing products, try to fetch them from Shopify
        if (missingIds.length > 0) {
          console.log(`Fetching ${missingIds.length} missing products from Shopify...`);
          const fetchedProducts = await fetchMissingProducts(missingIds);
          products.push(...fetchedProducts);
          
          // If still missing, create placeholder products
          const fetchedIds = fetchedProducts.map(p => p.id);
          const stillMissing = missingIds.filter(id => !fetchedIds.includes(id.toString()));
          stillMissing.forEach(id => {
            console.warn(`Creating placeholder for product ${id}`);
            const placeholder = {
              id: id.toString(),
              title: `Product ${id}`,
              handle: null,
              url: `/products/${id}`,
              featuredImage: '',
              images: [],
              price: 0,
              compareAtPrice: null,
              variantId: null,
              isPlaceholder: true
            };
            products.push(placeholder);
          });
        }

        console.log(`Fetched ${products.length} products from ${productIds.length} IDs`);
        return products;
      }

      // Fetch missing products from Shopify product pages
      async function fetchMissingProducts(productIds) {
        const fetchedProducts = [];
        
        for (const id of productIds) {
          try {
            // Try to fetch product JSON from Shopify
            // First, we need to get the product handle - try fetching from all_products or use a workaround
            const response = await fetch(`/products/${id}`, {
              method: 'GET',
              headers: {
                'Accept': 'text/html'
              }
            });
            
            if (response.ok) {
              const html = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Try to find product JSON in script tags
              const productJsonScripts = doc.querySelectorAll('script[type="application/json"][data-product-json], script[type="application/json"]');
              let productData = null;
              
              for (const script of productJsonScripts) {
                try {
                  const json = JSON.parse(script.textContent);
                  if (json.id && json.id.toString() === id.toString()) {
                    productData = json;
                    break;
                  }
                } catch (e) {
                  // Try next script
                }
              }
              
              // If no JSON found, try to extract from page
              if (!productData) {
                // Extract basic info from HTML
                const titleEl = doc.querySelector('h1, [data-product-title]');
                const priceEl = doc.querySelector('[data-product-price], .product-price');
                const imageEl = doc.querySelector('[data-product-image], .product-image img, .product__media img');
                const urlMatch = response.url.match(/\/products\/([^?#]+)/);
                const handle = urlMatch ? urlMatch[1] : null;
                
                if (titleEl || imageEl) {
                  productData = {
                    id: id.toString(),
                    title: titleEl ? titleEl.textContent.trim() : 'Product',
                    handle: handle,
                    url: `/products/${handle || id}`,
                    featuredImage: imageEl ? imageEl.src : '',
                    images: imageEl ? [imageEl.src] : [],
                    price: 0,
                    compareAtPrice: null,
                    variantId: null
                  };
                }
              }
              
              if (productData) {
                // Normalize the product data structure
                const normalized = {
                  id: productData.id ? productData.id.toString() : id.toString(),
                  title: productData.title || 'Product',
                  handle: productData.handle || productData.handleize || null,
                  url: productData.url || `/products/${productData.handle || id}`,
                  featuredImage: productData.featured_image || productData.featuredImage || (productData.images && productData.images[0]) || '',
                  images: productData.images || (productData.featured_image ? [productData.featured_image] : []),
                  price: productData.price || (productData.variants && productData.variants[0] && productData.variants[0].price) || 0,
                  compareAtPrice: productData.compare_at_price || (productData.variants && productData.variants[0] && productData.variants[0].compare_at_price) || null,
                  variantId: (productData.variants && productData.variants[0] && productData.variants[0].id) || null,
                  available: typeof productData.available === 'boolean'
                    ? productData.available
                    : !!(productData.variants && productData.variants.some(variant => variant.available))
                };
                
                // Store in localStorage for future use
                localStorage.setItem(`product_${id}`, JSON.stringify(normalized));
                fetchedProducts.push(normalized);
                console.log('Fetched and stored product:', normalized);
              }
            }
          } catch (error) {
            console.error(`Error fetching product ${id}:`, error);
          }
        }
        
        return fetchedProducts;
      }

      // Wishlist Items Component
      const WishlistItems = ({ translations }) => {
        const [wishlist, setWishlist] = useState([]);
        const [products, setProducts] = useState([]);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
          // Get wishlist from localStorage
          const wishlistIds = JSON.parse(localStorage.getItem('wishlist') || '[]');
          console.log('Wishlist IDs:', wishlistIds);
          setWishlist(wishlistIds);

          if (wishlistIds.length > 0) {
            fetchProducts(wishlistIds).then(fetchedProducts => {
              console.log('Setting products:', fetchedProducts);
              setProducts(fetchedProducts);
              setLoading(false);
            }).catch(error => {
              console.error('Error fetching products:', error);
              setLoading(false);
            });
          } else {
            console.log('Wishlist is empty');
            setLoading(false);
          }

          // Listen for wishlist updates
          const handleUpdate = () => {
            const updatedIds = JSON.parse(localStorage.getItem('wishlist') || '[]');
            setWishlist(updatedIds);
            if (updatedIds.length > 0) {
              fetchProducts(updatedIds).then(fetchedProducts => {
                setProducts(fetchedProducts);
              });
            } else {
              setProducts([]);
            }
          };

          window.addEventListener('wishlist-updated', handleUpdate);
          return () => window.removeEventListener('wishlist-updated', handleUpdate);
        }, []);

        if (loading) {
          return h('section', {
            className: 'w-full pb-8 lg:pb-14 px-3 lg:px-12 text-center'
          }, h('p', { className: 'text-dark' }, 'Loading...'));
        }

        if (wishlist.length === 0) {
          console.log('Wishlist is empty, showing empty state');
          return h(EmptyState, translations);
        }

        if (products.length === 0 && wishlist.length > 0) {
          // Products in wishlist but no data found
          return h('section', {
            className: 'w-full pb-8 lg:pb-14 px-3 lg:px-12'
          }, h('div', {
            className: 'w-full max-w-xl mx-auto bg-white rounded-xl border border-gray-200 p-6 text-center'
          }, [
            h('p', {
              className: 'text-lg font-medium text-dark mb-2'
            }, 'Product data not found'),
            h('p', {
              className: 'text-gray pt-2 mb-4'
            }, 'Your wishlist contains products, but their details are missing. Please visit the product pages and add them to your wishlist again by clicking the heart icon.'),
            h('div', {
              className: 'flex flex-col sm:flex-row gap-3 justify-center mt-4'
            }, [
              h('a', {
                href: '/collections',
                className: 'inline-block px-6 py-3 rounded-full font-medium text-white bg-blue hover:bg-blue-button transition-colors',
                style: { boxShadow: '4px 4px 0px 0px rgb(11,40,72)' }
              }, 'Browse Products'),
              h('button', {
                onClick: () => {
                  if (confirm('Clear wishlist? You can re-add products by visiting product pages.')) {
                    localStorage.removeItem('wishlist');
                    // Clear all product data
                    wishlist.forEach(id => {
                      localStorage.removeItem(`product_${id}`);
                    });
                    window.dispatchEvent(new Event('wishlist-updated'));
                  }
                },
                className: 'inline-block px-6 py-3 rounded-full font-medium text-dark bg-gray-200 hover:bg-gray-300 transition-colors border-2 border-gray-300'
              }, 'Clear Wishlist')
            ])
          ]));
        }

        if (products.length === 0) {
          console.log('No products found, showing empty state');
          return h(EmptyState, translations);
        }

        console.log('Rendering products:', products);
        return h('section', {
          className: 'w-full pb-8 lg:pb-14 px-3 lg:px-12 grid grid-cols-2 lg:grid-cols-5 gap-2'
        }, products.map(product => {
          if (!product || !product.id) {
            console.warn('Invalid product:', product);
            return null;
          }
          return h(ProductCard, { key: product.id || product.handle || product.title, product });
        }).filter(Boolean));
      };

      // Main Wishlist Component
      const Wishlist = ({ shopUrl, homeLink, translations }) => {
        return h('div', {}, [
          h(Hero, { homeLink, title: translations.title, home: translations.home }),
          h(WishlistItems, { translations })
        ]);
      };

      // Render the component
      try {
        // Try React 18 createRoot API first
        if (ReactDOM.createRoot) {
          const root = ReactDOM.createRoot(rootElement);
          root.render(h(Wishlist, props));
        } else {
          // Fallback to ReactDOM.render for older React versions
          ReactDOM.render(h(Wishlist, props), rootElement);
        }
      } catch (error) {
        console.error('Error rendering wishlist component:', error);
        rootElement.innerHTML = '<div style="padding: 2rem; text-align: center;"><p>Error loading wishlist. Please refresh the page.</p></div>';
      }
    }

    // Load React and ReactDOM if not already loaded
    if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
      const reactScript = document.createElement('script');
      reactScript.src = 'https://unpkg.com/react@18/umd/react.production.min.js';
      reactScript.crossOrigin = '';
      reactScript.onload = function() {
        const reactDOMScript = document.createElement('script');
        reactDOMScript.src = 'https://unpkg.com/react-dom@18/umd/react-dom.production.min.js';
        reactDOMScript.crossOrigin = '';
        reactDOMScript.onload = initWishlistReact;
        document.head.appendChild(reactDOMScript);
      };
      document.head.appendChild(reactScript);
    } else {
      initWishlistReact();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
